import { AxiosResponse } from "axios";
import { ServiceResponseData } from "../ServiceResponseData";

export class DeleteInstallationsResData extends ServiceResponseData {
    deletedInstallationNames: string[] = [];
    notDeletedInstallationNames: string[] = [];

    constructor(response: AxiosResponse) {
        super(response);
        this.deletedInstallationNames = [];
        if (response.data && response.data.Payload) {
            if (response.data.Payload.DeletedInstallationNames != null && response.data.Payload.DeletedInstallationNames.length > 0)
                this.deletedInstallationNames = response.data.Payload.DeletedInstallationNames;
            if (response.data.Payload.NotDeletedInstallationNames != null && response.data.Payload.NotDeletedInstallationNames.length > 0)
                this.notDeletedInstallationNames = response.data.Payload.NotDeletedInstallationNames;
        }
    }
}
